import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';
import { createQueryString } from 'services/production/utils/createQueryString';
import { M8ClientIncomeHistory } from 'services/production/types';

type Params = {
  page: number;
  idClient: number;
};

export const getClientIncomeHistory = async (
  params: Params
): Promise<M8ClientIncomeHistory[]> => {
  const fetchURL = getM8PartnerURL(
    `getClientIncomeHistory?${createQueryString(params)}`
  );

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return [];
};
